import React from "react";

interface AvatarProps {
  src?: string;
  alt?: string;
  fallback?: string;
  size?: number;
  className?: string;
}

export function Avatar({ src, alt = "", fallback, size = 40, className = "" }: AvatarProps) {
  const [errored, setErrored] = React.useState(false);
  const showImage = src && !errored;

  return (
    <div
      className={`flex items-center justify-center rounded-full bg-primary-100 text-primary-700 font-semibold overflow-hidden shrink-0 dark:bg-primary-900/40 dark:text-primary-300 ${className}`}
      style={{ width: size, height: size, fontSize: size * 0.4 }}
    >
      {showImage ? (
        <img
          src={src}
          alt={alt}
          onError={() => setErrored(true)}
          className="h-full w-full object-cover"
        />
      ) : (
        <span>{fallback?.charAt(0)?.toUpperCase() ?? "?"}</span>
      )}
    </div>
  );
}
